/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';
import { Country } from './country.model';

export enum CountriesActionTypes {
  AllCountriesRequested = '[Cities] All Countries Requested',
  AllCountriesLoaded = '[Cities] All Countries Loaded',
  AllCountriesFailed = '[Cities] All Countries Failed',
}

export const AllCountriesRequested = createAction(CountriesActionTypes.AllCountriesRequested);
export const AllCountriesLoaded = createAction(CountriesActionTypes.AllCountriesLoaded, props<{ countries: Country[] }>());
export const AllCountriesFailed = createAction(CountriesActionTypes.AllCountriesFailed);
